if (process.env.VUE_APP_NODE_BUILD_ENV == 'prod') {
  window.BonreeAgent &&
    window.BonreeAgent.BonreeStart({
      appId: 'b50cbb396145483bacf248cd049520aa',
      uploadAddrHttps: 'https://oneupload.bonree.com/RUM/upload',
      uploadAddrHttp: 'http://oneupload.bonree.com/RUM/upload',
      mc: [{ n: 'network', cs: { fc: 0 } }],
      reqHeaderTraceKey: ['tracestate', 'traceparent'],
      respHeaderTraceKey: ['traceresponse', 'x-br-response'],
      brss: false
    });
}
